import PropTypes from 'prop-types'

export default {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
}
